export default (el) => {
    const body = document.body;

    let toggleItems = document.querySelectorAll('[data-page-search-toggle]');
    let input = el.querySelector('input');

    toggleItems.forEach((toggle) => {
        toggle.addEventListener('click', (event) => {
            event.preventDefault();
            el.classList.toggle('-active');
            body.classList.toggle('-no-overflow');

            if (el.classList.contains('-active')) {
                input.focus();
            } else {
                input.value = '';
            }
        });
    });

    input.addEventListener('keyup', function() {
        let minlength = 2;

        if (input.value.length > minlength) {
            let xhttp = new XMLHttpRequest();
            xhttp.open("GET", input.dataset.autocompleteUri + "?q=" + input.value, true);
            xhttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            xhttp.onreadystatechange = function() {
                if(this.readyState === 4 && this.status === 200) {
                    let response = JSON.parse(this.response);

                    let formElement = el.querySelector('[data-page-search-container]');

                    let autocompleteContainer = el.querySelector('[data-page-search-autocomplete]');

                    if (autocompleteContainer === null) {
                        autocompleteContainer = document.createElement('div');
                        autocompleteContainer.setAttribute('class', 'page-search__autocomplete');
                        autocompleteContainer.setAttribute('data-page-search-autocomplete', true);
                    }

                    let list = document.createElement('ul');
                    for (let i = 0; i < response.length; i++) {
                        let li = document.createElement('li');
                        let a = document.createElement('a');
                        a.textContent = response[i].text;
                        a.href = response[i].uri;
                        li.appendChild(a);
                        list.appendChild(li);
                    }

                    if (autocompleteContainer.childNodes[0] !== undefined) {
                        autocompleteContainer.replaceChild(list, autocompleteContainer.childNodes[0]);
                    } else {
                        autocompleteContainer.appendChild(list);
                    }
                    formElement.appendChild(autocompleteContainer);
                }
            };
            xhttp.send();
        }
    });
};
